<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CXnCVU/tc-custom/9781504084567.jpg?1720018436271" alt="This image is the cover for the book Decameron"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Decameron
      </h1>
      <p class="bookDescription body article font2">
        <p><b>In this bold and bawdy fourteenth-century Italian masterpiece, ten friends escape the plague by telling a series of wise, witty, and irreverent stories.</b></p> It’s the summer of 1348 and Venice is overrun by the Black Death. Taking refuge in an isolated country house, ten young friends agree to tell each other stories to pass the time. Choosing a new theme each day, the seven women and three men take turns spinning yarns about the world they have left behind. Through this framing device, Giovanni Boccaccio delivers a hundred tales that capture the great tragicomedy of Medieval life in all its duplicity, passion, and pathos.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Giovanni Boccaccio
      </h2>
      
      <p class="authorDescription body article">Giovanni Boccaccio was an Italian writer, poet, correspondent of Petrarch, and an important Renaissance humanist. Born in the town of Certaldo in 1313, he was the son of Florentine merchant Boccaccino di Chellino and an unknown woman; he was likely born out of wedlock. His father introduced him to the Neapolitan nobility and the French-influenced court of Robert the Wise (the king of Naples) in the 1330s. At this time, Boccaccio fell in love with a married daughter of the king, who is portrayed as &ldquo;Fiammetta&rdquo; in many of his prose romances. From 1350, Boccaccio became closely involved with Italian humanism (although less of a scholar) and also with the Florentine government. His final years were troubled by illnesses, some relating to obesity and what would be described today as congestive heart failure. He died in 1375 in Certaldo, where he is buried. Upon his death, his entire collection was given to the monastery of Santo Spirito, in Florence, where it still resides.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40bb8a1b